<template>
    <span
        class="bg-gray-100 whitespace-nowrap rounded-full flex w-fit text-center hover:cursor-help"
        @mouseover="showPopover"
        @mouseleave="hidePopover"
        ref="pillElement"
    >
        <slot></slot>
        <PopoverHoverSmall
            v-if="isPopoverVisible"
            :xPosition="xPosition"
            :yPosition="yPosition"
        >
        <template v-slot:title>
            {{ popoverTitle }}
        </template>
        <template v-slot:body>
            {{ popoverBody }}
        </template>
        </PopoverHoverSmall>
    </span>
</template>

<script setup>
import { ref, defineProps } from 'vue'
import PopoverHoverSmall from './PopoverHoverSmall.vue'

const props = defineProps(['popoverTitle', 'popoverBody'])

const xPosition = ref(0)
const yPosition = ref(0)
const isPopoverVisible = ref(false)
const pillElement = ref(null)


function showPopover() {
    isPopoverVisible.value = true;
    xPosition.value = pillElement.value.getBoundingClientRect().right
    yPosition.value = pillElement.value.getBoundingClientRect().top
}

function hidePopover() {
    isPopoverVisible.value = false;
    xPosition.value = 0;
    yPosition.value = 0;
}



</script>